module.exports = __webpack_public_path__ + "img/other.47789f02.svg";